/**
 * This is the memword routes configuration.
 * Only configure routes in this file.
 * @memberOf memword Module
 * @namespace memword Routes
 */
import twofaProductAppTemplate from './2fa.productapp.html';

/**
 * @name config
 * @desc Configures the routes.
 * @param $stateProvider
 * @memberOf memword Module.memword Routes
 * @ngInject
 */
var config = function ($stateProvider) {
	/* Create the memword state and assign the template and controller. */

	$stateProvider
		.state('login.2fa.productapp', {
			url: '/register/productapp',
			template: twofaProductAppTemplate,
			controller: 'twofaProductAppController',
			controllerAs: 'vm'
		});

}

export default config;


// WEBPACK FOOTER //
// ./src/login/2fa/productapp/2fa.productapp.route.js